import { VendorItemSchema } from "@/schemas/vendor/vendor-item";
import { z } from "zod";
import env from "@/app/config/env";

export const NotificationSubscriptionSetupItemSchema = z.object({
  Id: z.string(),
  AccountId: z.string().optional(),
  ProductId: z.string().optional(),
  ProductName: z.string(),
  ProductImage: z
    .string()
    .transform((value) => (value ? `${env.hosts.image}/images/${value}` : ``)),
  VendorId: VendorItemSchema.shape.Id.optional(),
  VendorName: VendorItemSchema.shape.Name.optional(),
  Flow: z.string(),
  BusinessUnitId: z.string().optional(),
  BusinessUnitName: z.string().optional(),
  StatusCode: z.number().optional(),
  WarningHeader: z.string().optional(),
  WarningMessage: z.string().optional(),
  ReadyForSetup: z.boolean().optional(),
});

export type NotificationSubscriptionSetupItemType = z.infer<
  typeof NotificationSubscriptionSetupItemSchema
>;
